import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import {
  BarChart,
  Book,
  ChevronRight,
  CurrencyDollar,
  FileEarmarkPlus,
  GeoAlt,
  Key,
  Layers,
  Megaphone,
  Pencil,
  People,
  Robot,
  Rocket,
  Search,
  ShieldLock,
  Sliders,
  Speedometer2,
  Trash,
  Wrench,
} from 'react-bootstrap-icons';
import type { Tool } from '@/types/tools';
import './ToolCard.css';

const ICONS: Record<string, ReactNode> = {
  'bar-chart': <BarChart />,
  book: <Book />,
  currency: <CurrencyDollar />,
  'file-plus': <FileEarmarkPlus />,
  geo: <GeoAlt />,
  key: <Key />,
  layers: <Layers />,
  megaphone: <Megaphone />,
  pencil: <Pencil />,
  people: <People />,
  robot: <Robot />,
  rocket: <Rocket />,
  search: <Search />,
  'shield-lock': <ShieldLock />,
  sliders: <Sliders />,
  speedometer: <Speedometer2 />,
  trash: <Trash />,
};

interface ToolCardProps {
  tool: Tool;
}

/** One tool. The whole card opens it. */
export function ToolCard({ tool }: ToolCardProps) {
  return (
    <Link to={tool.route} className={`tool-card${tool.danger ? ' tool-card--danger' : ''}`}>
      <span className="tool-card__icon" aria-hidden="true">
        {(tool.icon && ICONS[tool.icon]) || <Wrench />}
      </span>
      <span className="tool-card__body">
        <span className="tool-card__name">{tool.name}</span>
        <span className="tool-card__desc">{tool.description}</span>
      </span>
      <ChevronRight className="tool-card__chevron" aria-hidden="true" />
    </Link>
  );
}

export default ToolCard;
